import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { Paragraph, Button, ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { 
  APPLICATION_MODE_NEW, 
  ROUTE_PATH
} from "../../../app/constants";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { replaceUrlParams } from "../../../app/utils";

export const RoleConfirmationView = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const [showRoleConfirmationError, setShowRoleConfirmationError] = useState(false);

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;

  const title = "Your role at your company.";
  const p1Text = `As the ${isPrincipalBroker ? 'principal broker for your brokerage' : 'compliance officer for your company'}, you must have one of the following roles at your company: director, partner, officer, or sole proprietor.` ;
  const p2Text = `Most companies in Nova Scotia are listed in Registry of Joint Stock Companies. If you are sure of your role, you can find your company profile in the <a style="text-decoration: underline" href="https://rjsc.novascotia.ca/" target="_blank">Registry of Joint Stock Companies.</a>`;
  const p3Text = `Are you a director, partner, officer or sole proprietor?` 

  const handleNext = (confirmRole) => () => {
    setShowRoleConfirmationError(!confirmRole);

    let nextPath;
    if(isPrincipalBroker) {
      nextPath = replaceUrlParams(ROUTE_PATH.NS_LOGIN,application,APPLICATION_MODE_NEW)
      dispatch(push(nextPath));
    }
    else {
      dispatch(push(`/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_RESIDENCY_CONFIRMATION}`));
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props}
          hideSaveAndExit 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>
        </div>
      </div>

      <div className="row topMarginLarge bottomMarginLarger">
        <div className="col-xs-12 col-lg-8">
          <Paragraph 
            text={[p1Text,p2Text, p3Text]}
          />
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
          {showRoleConfirmationError &&
            ErrorWithString(`The ${isPrincipalBroker ? 'Principal Broker' : 'Compliance Officer'} must be a director,partner,officer or sole proprietor for the company.`)
          }
        </div>
      </div>
    </div>
  );
};
